/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.OMS {
    var x;
    @Serenity.Decorators.registerClass()
    export class RawMaterialMasterEditor extends _Ext.GridEditorBase<RawMaterialMasterRow> {
        protected getColumnsKey() { return "OMS.RawMaterialMaster"; }
        protected getDialogType() { return RawMaterialMasterDialog; }
        protected getLocalTextPrefix() { return RawMaterialMasterRow.localTextPrefix; }
         
        protected form: RawMaterialMasterForm;

        
        constructor(container: JQuery) { 
            super(container); 
            this.slickGrid.setOptions({ rowHeight: 30 });


        }
        public DisableAddButton() {
            this.toolbar.element.hide();
            this.element.hide();
        }

        public EnableAddButton() {
            this.toolbar.element.show();
            this.element.show();
            


        } 
        
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.RawMaterialMasterSelectGrid;
            // grid.apply(this.rowSelection = new Serenity.GridRowSelectionMixin(this));
            //grid.apply(this.getColumns = (Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            buttons.push({
                title: "Pick Products",
                cssClass: "add-button",
                onClick: () => {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        alert('Length' + selectedItems.length);
                        var orddetails = [];
                        var bomdetails = [];
                        selectedItems2.forEach(function (value) {
                            var prdid = value.BomId; 
                            var Type =value.CategoryCode;
                            var SubType =value.SubCategoryCode; 
                            var Rate =value.Rate;


                            var ProductBom: ProductBOMRow = {
                                BOMProductId: prdid,
                                ProductCode: value.ProductCode,
                                CategoryCode: Type,
                                SubCategoryCode: SubType,
                                BomRate: Rate,
                                Pieces: value.Pieces,
                                Weight: value.Weight

                                //othpcs: value.other_pieces,
                                //othwt: value.other_weight,
                                //clspcs: value.color_stone_pieces,
                                //clswt: value.color_stone_weight,
                                //netwt: value.net_weight,
                                //netamount: value.amount,
                                //diapcs: value.diamond_pieces,
                                //diawt: value.diamond_weight,
                                //bomdetails: bomdetails
                            };
                            orddetails.push(ProductBom);

                        });
                        
                        alert('Length details' + orddetails.length);
                        for (let orderDetail of orddetails) {
                            orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                            alert('ID ' + orderDetail.PrdId);
                            var x = orderDetail;
                            this.view.addItem(orderDetail);

                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }/*
        validateEntity(row: RawMaterialMasterRow, id: number) {
            if (!super.validateEntity(row, id))
                return false;


            //duplicate Component
            row.Prod = Q.toId(row.Product_Bom_Id);

            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.Product_Bom_Id === row.Product_Bom_Id);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Component is already in product details!');
               return false;
            }

             //update values in grid

            row.Product_Code = ProductMasterRow.getLookup().itemById[row.Product_Bom_Id].Product_Code;
            row.FixedName = FixedCodeRow.getLookup().itemById[row.Calculate_On].FixedName;
            row.Attribute = CommonAttributesRow.getLookup().itemById[row.Attribute_Id].Attribute;
            row.ItemType = CommonAttributesRow.getLookup().itemById[row.Attribute_Id].ItemType;
            return true;
        }  */  

    }
}